/**
 * Initial-based avatar with deterministic color from a string hash.
 * Same input always produces the same color across renders / sessions.
 */

const PALETTE = [
  ['bg-emerald-500/15', 'text-emerald-300', 'ring-emerald-500/20'],
  ['bg-sky-500/15', 'text-sky-300', 'ring-sky-500/20'],
  ['bg-violet-500/15', 'text-violet-300', 'ring-violet-500/20'],
  ['bg-amber-500/15', 'text-amber-300', 'ring-amber-500/20'],
  ['bg-rose-500/15', 'text-rose-300', 'ring-rose-500/20'],
  ['bg-cyan-500/15', 'text-cyan-300', 'ring-cyan-500/20'],
  ['bg-fuchsia-500/15', 'text-fuchsia-300', 'ring-fuchsia-500/20'],
  ['bg-lime-500/15', 'text-lime-300', 'ring-lime-500/20'],
];

function hash(s: string): number {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) | 0;
  return Math.abs(h);
}

interface Props {
  name: string;
  size?: 'sm' | 'md';
}

export function Avatar({ name, size = 'sm' }: Props) {
  const initial = (name.match(/[a-z0-9]/i)?.[0] ?? '?').toUpperCase();
  const palette = PALETTE[hash(name.toLowerCase()) % PALETTE.length];
  const sizeCls =
    size === 'md' ? 'h-9 w-9 text-sm' : 'h-7 w-7 text-xs';
  return (
    <span
      className={`inline-flex shrink-0 items-center justify-center rounded-md font-medium ring-1 ring-inset ${palette[0]} ${palette[1]} ${palette[2]} ${sizeCls}`}
    >
      {initial}
    </span>
  );
}
